import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"icon-close\"><g><path d=\"M9.5,8L16,14.5L14.5,16L8,9.5L1.5,16L0,14.5L6.5,8L0,1.5L1.5,0L8,6.5L14.5,0L16,1.5L9.5,8Z\" fill=\"#FFFFFF\" fill-opacity=\"1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol